export const API_NAME_MAPBOX = "Mapbox-API";
